import React from "react";
import { Link } from "react-router-dom";
import "../assets/styles/_cta-list.scss";

export const CtaList = () => {
  return (
    <div className="cta-box">
      <Link to="/contact" className="mail-box">
        <p>
          メールでの
          <br />
          お問い合わせはこちら
        </p>
        <p className="circle"></p>
      </Link>
      <a href="tel:03-5817-4752" className="tel-box">
        <p>お電話でのお問い合わせ</p>
        <div className="number">
          <p>０３ - ５８１７ - ４７５２</p>
          <span>
            受付時間：10:00〜19:00
            <br />
            定休日：毎週火曜日
          </span>
        </div>
      </a>
    </div>
  );
};
